export const splitCamelCase = (val: string): string => val.replace(/([A-Z][a-z\d]+)/g, (match) => match + " ");